<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="col-6">
    <p class="titleFont">
      {{ "label.claim.claimDetails.occupationDetails" | translate }}
    </p>
  </div>
  <div class="card mt-2 px-4 pt-4 pb-4">
    <!--label-->
    <div class="row mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12"></div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label class="purpleLabel">{{ "label.claim.claimDetails.beforeDisability" | translate }}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label class="purpleLabel">{{ "label.claim.claimDetails.afterDisability" | translate }}</label>
      </div>
    </div>
    <!--Name of the Employer-->
    <div class="row mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label>{{ "label.claim.claimDetails.nameOfEmployer" | translate }}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 open-expan">
        <custom-input-text
        (valueChange)="onChangeValue($event, 'employerNameBeforeDisability')"
          [model]="occupationModule?.employerNameBeforeDisability"
          [disabled]="true"></custom-input-text>
        <img
          class="open-icon"
          src="{{ openIcon }}"
          alt=""
          (click)="openDutiesBeforeDisability()"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 open-expan">
        <custom-input-text
        (valueChange)="onChangeValue($event, 'employerNameAfterDisability')"
          [model]="occupationModule?.employerNameAfterDisability"
          [disabled]="true"></custom-input-text>
        <img
          class="open-icon"
          src="{{ openIcon }}"
          alt=""
          (click)="openDutiesAfetrDisability()"
        />
      </div>
    </div>
    <!--Date First day of work-->
    <div class="row mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label>{{ "label.claim.claimDetails.firstDayWorkDate" | translate }}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-date-picker digitDate
        [placeholder]="true"
        (valueChange)="
          onChangeValue($event, 'firstDayOfWorkBeforeDisability')
        "
        [model]="occupationModule?.firstDayOfWorkBeforeDisability"
        [disabled]="true"></custom-date-picker>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-date-picker digitDate
        [placeholder]="true"
        (valueChange)="onChangeValue($event, 'firstDayOfWorkAfterDisability')"
        [model]="occupationModule?.firstDayOfWorkAfterDisability"
        [disabled]="true"></custom-date-picker>
      </div>
    </div>
    <!--Date last day of work-->
    <div class="row mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label>{{ "label.claim.claimDetails.lastDayWorkDate" | translate }}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-date-picker digitDate
        [placeholder]="true"
        (valueChange)="onChangeValue($event, 'lastDayOfWorkBeforeDisability')"
        [model]="occupationModule?.lastDayOfWorkBeforeDisability"
        [disabled]="true"></custom-date-picker>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-date-picker digitDate
        [placeholder]="true"
        (valueChange)="onChangeValue($event, 'lastDayOfWorkAfterDisability')"
        [model]="occupationModule?.lastDayOfWorkAfterDisability"
        [disabled]="true"></custom-date-picker>
      </div>
    </div>
    <!--Monthly Income-->
    <div class="row mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <label>{{ "label.claim.claimDetails.monthlyIncome" | translate }}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-input-text
        digitOnly
          (valueChange)="onChangeValue($event, 'monthyIncomeBeforeDisability')"
          [model]="occupationModule?.monthyIncomeBeforeDisability"
          [disabled]="true"></custom-input-text>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <custom-input-text
        digitOnly
          (valueChange)="onChangeValue($event, 'monthyIncomeAfterDisability')"
          [model]="occupationModule?.monthyIncomeAfterDisability"
          [disabled]="true"></custom-input-text>
      </div>
    </div>
  </div>

  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'label.claim.claimDetails.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'label.claim.claimDetails.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>
